import { Select as StyledSelect } from './styles';

export default StyledSelect;
